import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { FichaProductosFunds } from 'src/app/home/_models/ficha-productos-funds';

@Component({
  selector: 'app-ficha-cartera',
  templateUrl: './ficha-cartera.component.html',
  styleUrls: ['./ficha-cartera.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule
  ]
})


export class FichaCarteraComponent{
  @Input() criptoCardData: FichaProductosFunds;
  isHovered:boolean = false;  

   setHovered(isHovered: boolean): void {
    this.isHovered = isHovered;
  }
}
